// @flow

import React from 'react';
import Box from '@mui/material/Box';
import { Link as RouterLink } from 'react-router-dom';
import PrimaryButton from './PrimaryButton';
import Container from './Container';
import logo from '../../../assets/askneo-favicon.png';

type Props = {
  variant?: 'light' | 'dark' | 'transparent',
  showCta?: boolean,
  ctaTo?: string,
  ctaLabel?: string
};

const TopNav = ({
  variant = 'dark',
  showCta = true,
  ctaTo = '/signup',
  ctaLabel = 'Start free trial'
}: Props) => {
  return (
    <Box
      component="nav"
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 10,
        py: 2.5,
        backgroundColor: variant === 'light' ? 'background.default' : 'transparent',
        borderBottom: variant === 'light' ? (theme) => `1px solid ${theme.palette.v2.neutral[200]}` : 'none'
      }}
    >
      <Container>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box
            component={RouterLink}
            to="/"
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 1.25,
              textDecoration: 'none',
              color: variant === 'light' ? 'text.primary' : '#FFFFFF'
            }}
            aria-label="AskNeo home"
          >
            <Box
              component="img"
              src={logo}
              alt=""
              sx={{ height: 36, width: 36, display: 'block', borderRadius: '50%' }}
            />
            <Box component="span" sx={{ fontWeight: 700, fontSize: '1.125rem', letterSpacing: '-0.01em' }}>
              AskNeo
            </Box>
          </Box>
          {showCta && (
            <PrimaryButton to={ctaTo} size="medium" color={variant === 'light' ? 'primary' : 'secondary'}>
              {ctaLabel}
            </PrimaryButton>
          )}
        </Box>
      </Container>
    </Box>
  );
};

export default TopNav;
